import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from '../../../../hooks';

// Dummy data
const note = [
  `Selection of monthly winners will be by ranking (highest points ranking).  In case of a tie in points, priority will be given to the customer with the higher tenure. If there is a tie in tenure, priority will be given to the customer with the highest ARPU for the past three months prior to the commencement of the promo.`,
  `Winners will be given a two week notification to claim their prizes or indicate interest in the prize. In the event that the winners selected are not available to claim the prizes, the prizes will be allocated to the next customer in order of rank.`
];

const tips = [
  "Promo Starts from 1st Sep to 30th Nov, 2022",
  "Winners will be notified via in-app Notification & Phone call",
  "Click My Points to Check points built so far",
];

const usePulseNChillHome = () => {
  const { themeContext, theme } = useTheme();
  const {
    selectedLoyaltyData,
  } = useLoyalty();
  const { promoData: { bannerImage, tailImage } = {} } = selectedLoyaltyData || {};
  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return {
    background,
    history,
    bannerImage,
    tailImage,
    tips,
    note
  }
}

export default usePulseNChillHome